// extracted by mini-css-extract-plugin
module.exports = {"ctaParent":"CTA_ctaParent__SWcjJ","brushStroke1":"CTA_brushStroke1__Y32OR","brushStroke2":"CTA_brushStroke2__0cEJC"};